<div class="creation-page">
  <div class="creation-page-actions">
    @for (r of routes; track $index) {
      <a class="creation-page-action" [routerLink]="['/app/create', r.route]">
        <mat-icon svgIcon="{{ r.icon }}" class="creation-page-action-icon"></mat-icon>
        {{ r.label }}
      </a>
    }
  </div>
</div>
